/* klaviyo-signup.js — Shopify Email customer signup + optional Klaviyo SMS */
'use strict';

(function () {
  window.HomestarMarketing = window.HomestarMarketing || {};

  function getConfig() {
    if (window.HomestarMarketing.config) return window.HomestarMarketing.config;
    var el = document.getElementById('HomestarMarketingConfig');
    if (!el) return {};
    try {
      window.HomestarMarketing.config = JSON.parse(el.textContent || '{}');
    } catch (e) {
      window.HomestarMarketing.config = {};
    }
    return window.HomestarMarketing.config;
  }

  function e164FromUsDigits(digits) {
    if (!digits) return null;
    var d = String(digits).replace(/\D/g, '');
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return null;
    return '+1' + d;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function postCustomerForm(form) {
    var action = (form && (form.getAttribute('data-action') || form.action)) || '/contact';
    var formData = new FormData(form);

    // Preference radios are not Shopify contact fields — fold into tags.
    var preference = formData.get('preference');
    formData.delete('preference');
    formData.delete('terms');
    if (preference) {
      var tags = String(formData.get('contact[tags]') || 'newsletter, shopify-email');
      if (tags.indexOf('pref-') === -1) {
        formData.set('contact[tags]', tags + ', pref-' + preference);
      }
    }
    if (!formData.get('contact[accepts_marketing]')) {
      formData.set('contact[accepts_marketing]', 'true');
    }

    return fetch(action, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin'
    }).then(function (res) {
      if (res.ok || res.status === 302 || res.status === 422) {
        return { ok: true, status: res.status, provider: 'shopify' };
      }
      return res.text().then(function (text) {
        var err = new Error('Shopify email signup failed (' + res.status + ')');
        err.status = res.status;
        err.body = text;
        throw err;
      });
    });
  }

  /**
   * Create/update a Shopify customer with email marketing consent.
   * Pass the rendered {% form 'customer' %} element so hCaptcha can attach.
   */
  window.HomestarMarketing.subscribeShopifyEmail = function (entry) {
    var form = entry && entry.form;
    var email = String((entry && entry.email) || (form && form.querySelector('[name="contact[email]"]') && form.querySelector('[name="contact[email]"]').value) || '')
      .trim()
      .toLowerCase();

    if (!isValidEmail(email)) {
      return Promise.reject(new Error('Invalid email'));
    }

    if (form) {
      var emailInput = form.querySelector('[name="contact[email]"]');
      if (emailInput) emailInput.value = email;

      return new Promise(function (resolve, reject) {
        function submitProtected() {
          postCustomerForm(form).then(resolve).catch(reject);
        }

        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          try {
            window.Shopify.captcha.protect(form, submitProtected);
          } catch (e) {
            submitProtected();
          }
        } else {
          submitProtected();
        }
      });
    }

    // Fallback without a form node (less reliable when store captcha is on).
    var tags = ['newsletter', 'shopify-email'];
    if (entry && entry.source) tags.push(String(entry.source));
    if (entry && entry.preference) tags.push('pref-' + String(entry.preference));
    if (entry && entry.discountCode) tags.push('code-' + String(entry.discountCode));

    var body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[tags]', tags.join(', '));
    body.set('contact[accepts_marketing]', 'true');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: body.toString(),
      credentials: 'same-origin'
    }).then(function (res) {
      if (res.ok || res.status === 302 || res.status === 422) {
        return { ok: true, status: res.status, email: email, provider: 'shopify' };
      }
      return res.text().then(function (text) {
        var err = new Error('Shopify email signup failed (' + res.status + ')');
        err.status = res.status;
        err.body = text;
        throw err;
      });
    });
  };

  window.HomestarMarketing.isValidEmail = isValidEmail;

  /** Accept raw List ID or a pasted Klaviyo list URL. */
  function normalizeListId(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/\/list\/([A-Za-z0-9]+)/i);
    if (m) return m[1];
    m = s.match(/lists?\/([A-Za-z0-9]+)/i);
    if (m) return m[1];
    return s.replace(/^[#/?]+/, '').split(/[/?#]/)[0];
  }

  /**
   * Subscribe a phone (and optional profile props) to the Klaviyo list.
   * Returns a Promise. Resolves even when Klaviyo is not configured (skipped).
   */
  window.HomestarMarketing.subscribe = function (entry) {
    // Prefer Shopify Email when an email is present.
    if (entry && entry.email) {
      return window.HomestarMarketing.subscribeShopifyEmail(entry);
    }

    var cfg = getConfig();
    var companyId = (cfg.klaviyoCompanyId || '').trim();
    var listId = normalizeListId(cfg.klaviyoListId);
    var phone = e164FromUsDigits(entry && (entry.phone || entry.formatted));

    if (!companyId || !listId || !phone) {
      return Promise.resolve({ ok: true, skipped: true });
    }

    var properties = {
      signup_source: (entry && entry.source) || 'homestar_website',
      discount_code: (entry && entry.discountCode) || cfg.discountCode || ''
    };
    if (entry && entry.preference) properties.shopping_preference = entry.preference;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Homestar Website',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                phone_number: phone,
                properties: properties,
                subscriptions: {
                  sms: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          Accept: 'application/json',
          revision: '2025-04-15'
        },
        body: JSON.stringify(payload),
        keepalive: true
      }
    ).then(function (res) {
      if (res.ok || res.status === 202 || res.status === 204) {
        return { ok: true, status: res.status };
      }
      return res.text().then(function (body) {
        var err = new Error('Klaviyo subscribe failed (' + res.status + ')');
        err.status = res.status;
        err.body = body;
        throw err;
      });
    });
  };
})();
